import React from "react";
import { Typography } from "top-brains-ui";
import styles from "@src/pages/login/set-password-link-expired/SetPasswordLinkExpired.module.scss";
import passwordLinkExpired from "@src/assets/set-pass-exp-img.svg";
// import { WEBSITE_COLORS } from "@src/styles/ColorConstants";

const SetPasswordLinkExpired: React.FC = () => {
  return (
    <div className={styles.container} style={{minHeight: "66vh"}}>
      <div className={styles.msgTitle}>
        <Typography fontWeight="semi-bold" fontSize={24} color="var(--modal-heading-color)" className={styles.linkExpired}>
          Your set password link is expired !
        </Typography>
      </div>
      <div className={styles.imageContainer}>
        <img src={passwordLinkExpired} alt="password_link_img" />
      </div>
      <Typography fontSize={16} color="var(--modal-body-color)" className={styles.description}>
          New set password link is sent to your email!
        </Typography>
    </div>
  );
};

export default SetPasswordLinkExpired;
